import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-xl font-bold text-primary mb-2" }
const _hoisted_2 = { class: "text-sm text-gris80 mb-4" }
const _hoisted_3 = { class: "grid gap-4" }
const _hoisted_4 = { class: "flex items-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-primary flex-shrink-0",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
  })
], -1)
const _hoisted_6 = { class: "ml-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "text-sm font-bold text-left text-primary" }, " Línea telefónica ", -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "flex items-start" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-primary flex-shrink-0",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
  })
], -1)
const _hoisted_11 = { class: "ml-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", { class: "text-sm font-bold text-left text-primary" }, " Correo electrónico ", -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-start" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-6 w-6 text-primary flex-shrink-0",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-4" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "text-sm font-bold text-left text-primary" }, " Horario de atención "),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gris120" }, " Lunes a viernes de 8:00 a.m. a 5:00 p.m. ")
  ])
], -1)
const _hoisted_15 = { class: "flex justify-center mt-6" }
const _hoisted_16 = {
  key: 1,
  class: "fixed inset-0 z-20 bg-black opacity-25"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isVisible)
      ? (_openBlock(), _createBlock(_component_NewModal, {
          key: 0,
          "custom-class": 'p-4 lg:p-6 max-w-2xl w-80 lg:w-96 bg-white rounded-lg',
          onCloseModal: _ctx.close
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.description), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("a", {
                    href: `tel:${_ctx.phoneHref}`,
                    class: "text-sm text-gris120 hover:underline"
                  }, _toDisplayString(_ctx.phone), 9, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("a", {
                    href: `mailto:${_ctx.email}`,
                    class: "text-sm text-gris120 hover:underline"
                  }, _toDisplayString(_ctx.email), 9, _hoisted_13)
                ])
              ]),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "px-6 py-2 text-sm font-normal text-white rounded-lg bg-primary hover:opacity-90 focus:outline-none"
              }, " Aceptar ")
            ])
          ]),
          _: 1
        }, 8, ["onCloseModal"]))
      : _createCommentVNode("", true),
    (_ctx.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16))
      : _createCommentVNode("", true)
  ], 64))
}